module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Calculadora de patrimonio",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Calculadora"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("de")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" patrimonio")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Calculadora de patrimonio',
      "videoEmbed": "ADMINISTRACIONDINERO49CalculadoraDePatrimonioa.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md6": "",
      "mb-5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 230,
      "imaSrc": "contenido/diapositiva_16",
      "imaAlt": "Mujer sonriendo con la mano en la cintura"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-left"
  }, [_vm._v("\n        Ahora que conoce en qué consisten los "), _c('strong', [_vm._v("activos")]), _vm._v(" y los "), _c('strong', [_vm._v("pasivos")]), _vm._v(",\n        está listo para calcular su "), _c('strong', [_vm._v("patrimonio")]), _vm._v("."), _c('br'), _c('br'), _vm._v("\n\n        Para lograrlo dispondrá de una útil herramienta:\n        la "), _c('strong', [_vm._v("calculadora de patrimonio.")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b02cea0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-49.vue
// module id = 1021
// module chunks = 1